import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  Flex,
  useToast
} from '@chakra-ui/react';
import { QRCodeCanvas } from 'qrcode.react';
import { useEffect } from 'react';

interface IUrlShortenerQrCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title?: string;
}

export default function UrlShortenerQrCodeModal({ isOpen, onClose, url, title }: IUrlShortenerQrCodeModalProps) {
  const toast = useToast();

  const fullUrl = `https://abra.com.br/short/${url}`;

  useEffect(() => {
    // Limpa o toast ao abrir/fechar
    return () => toast.closeAll();
  }, [isOpen]);

  const handleDownload = () => {
    const canvas = document.getElementById('abra-qrcode-canvas') as HTMLCanvasElement | null;
    if (!canvas) return;
    const pngUrl = canvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${title || 'qrcode'}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    toast({ title: 'Download iniciado', status: 'success', duration: 2000 });
  };

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>QR Code</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" alignItems="center" gap={4}>
            <QRCodeCanvas value={fullUrl} size={220} id="abra-qrcode-canvas" includeMargin={true} />
            <div style={{ wordBreak: 'break-all', textAlign: 'center', fontSize: 14 }}>{fullUrl}</div>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="magenta" mr={3} onClick={handleDownload}>
            Baixar PNG
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  );
}
